import {
  ProfielEditie,
  ProfielMethode,
  ProfielNiveau,
  ProfielWiskundeType,
} from "./profiel_types";

export interface NiveauOption {
  niveau: ProfielNiveau;
  label: string;
  jaren: number[];
  autoEditie?: ProfielEditie;
  wiskundeType?: ProfielWiskundeType;
}

export interface MethodeConfig {
  autoEditie?: Partial<Record<number, ProfielEditie>>;
  niveauOptions: NiveauOption[];
}

const getalEnRuimteConfig: MethodeConfig = {
  niveauOptions: [
    // Onderbouw
    { niveau: "VWO", label: "VWO", jaren: [1, 2] },
    { niveau: "VWO", label: "VWO", jaren: [3] },
    { niveau: "VMBOKGT", label: "VMBO-KGT", jaren: [1, 2, 3] },
    { niveau: "VMBOTHAVO", label: "VMBO-T/HAVO", jaren: [1, 2] },
    { niveau: "HAVOVWO", label: "HAVO/VWO", jaren: [1, 2] },
    { niveau: "VMBOBK", label: "VMBO-BK", jaren: [1, 2] },
    { niveau: "VMBOB", label: "VMBO-B", jaren: [3] },
    // The separate vmbo-k lane exists in editie 13 only (Jaar3/Jaar4 Deel1+2);
    // editie 12 has no VMBOK books, so the editie step is skipped.
    { niveau: "VMBOK", label: "VMBO-K", jaren: [3, 4], autoEditie: 13 },
    { niveau: "HAVO", label: "HAVO", jaren: [3] },
    // Bovenbouw
    { niveau: "VWO", label: "VWO A", jaren: [4, 5, 6], wiskundeType: "A" },
    { niveau: "VWO", label: "VWO B", jaren: [4, 5, 6], wiskundeType: "B" },
    // Wiskunde C shares the AC books (stored as wiskundeType "A") for deel 1
    // and 2 and gets its own book in deel 3; the backend resolves that per deel.
    { niveau: "VWO", label: "VWO C", jaren: [4, 5, 6], wiskundeType: "C" },
    { niveau: "HAVO", label: "HAVO A", jaren: [4, 5], wiskundeType: "A" },
    { niveau: "HAVO", label: "HAVO B", jaren: [4, 5], wiskundeType: "B" },
    { niveau: "VMBOKGT", label: "VMBO-KGT", jaren: [4] },
    { niveau: "VMBOB", label: "VMBO-B", jaren: [4] },
  ],
};

const moderneWiskundeConfig: MethodeConfig = {
  autoEditie: { 5: 12, 6: 12 },
  niveauOptions: [
    // Onderbouw
    { niveau: "VWO", label: "VWO", jaren: [1, 2, 3] },
    { niveau: "VMBOKGT", label: "VMBO-KGT", jaren: [1, 2] },
    { niveau: "VMBOGTHAVO", label: "VMBO-GT/HAVO", jaren: [1, 2] },
    { niveau: "HAVOVWO", label: "HAVO/VWO", jaren: [1, 2] },
    { niveau: "VMBOB", label: "VMBO-B", jaren: [1, 2, 3] },
    { niveau: "HAVO", label: "HAVO", jaren: [3] },
    // Bovenbouw
    { niveau: "VWO", label: "VWO A", jaren: [4, 5, 6], wiskundeType: "A", autoEditie: 12 },
    { niveau: "VWO", label: "VWO B", jaren: [4, 5, 6], wiskundeType: "B", autoEditie: 12 },
    { niveau: "HAVO", label: "HAVO A", jaren: [4, 5], wiskundeType: "A", autoEditie: 12 },
    { niveau: "HAVO", label: "HAVO B", jaren: [4, 5], wiskundeType: "B", autoEditie: 12 },
    { niveau: "VMBOGT", label: "VMBO-GT", jaren: [3, 4] },
    { niveau: "VMBOB", label: "VMBO-B", jaren: [4] },
  ],
};

const methodeConfigs: Record<ProfielMethode, MethodeConfig> = {
  "Getal & Ruimte": getalEnRuimteConfig,
  "Moderne Wiskunde": moderneWiskundeConfig,
};

export function getConfigForMethode(methode: ProfielMethode): MethodeConfig {
  return methodeConfigs[methode];
}

export function getOptionsForMethode(methode: ProfielMethode): NiveauOption[] {
  return methodeConfigs[methode].niveauOptions;
}
